import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import ContractTypeEditor from "../../editors/personInfo/contractType";

const ContractTypes: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.ContractTypesList}
			endpoint={Endpoint.ContractTypes}
			addScreen={{ screen: ContractTypeEditor, isAllowed: hasPermission(Permission.ContractTypesAdd) }}
			editScreen={{ screen: ContractTypeEditor, isAllowed: hasPermission(Permission.ContractTypesUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.ContractTypesDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default ContractTypes;
